<div class="flex-fill d-flex flex-column" *ngIf="vendor">
    <div class="btn-toolbar mx-3 mb-0 mt-3">
        <button type="button" (click)="save()" class="btn btn-primary me-2" *ngIf="hasChanges()">Save</button>
        <button type="button" (click)="cancel()" class="btn btn-success" *ngIf="hasChanges()">Cancel</button>
        <button type="button" (click)="close()" class="btn btn-primary" *ngIf="!hasChanges()">Close</button>
        <button type="button" (click)="auditLog()" class="btn btn-sm btn-info ms-auto" *ngIf="!hasChanges()">Audit Log</button>
    </div>
    <div class="grid-fill m-3">
        <dx-form [formData]="vendor" *ngIf="vendor" [colCount]="2">
            <dxi-item itemType="group">
                <dxi-item itemType="group" caption="Vendor Information">
                    <dxi-item dataField="companyName" [label]="{ text: 'Company' }" [isRequired]="true"></dxi-item>
                    <dxi-item dataField="contactName" [label]="{ text: 'Contact' }"></dxi-item>
                    <dxi-item dataField="email" [label]="{ text: 'Email' }"> </dxi-item>
                    <dxi-item dataField="remitEmail" [label]="{ text: 'Remit Email' }"> </dxi-item>
                    <dxi-item itemType="group" [colCount]="2">
                        <dxi-item dataField="phone" [label]="{ text: 'Phone' }"></dxi-item>
                        <dxi-item dataField="fax" [label]="{ text: 'Fax' }"></dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="3">
                        <dxi-item dataField="quickBooksId" [label]="{ text: 'QB Id' }" [editorOptions]="{ disabled: true }"></dxi-item>
                        <dxi-item dataField="quickBooksLastExport" [label]="{ text: 'Last Export' }" [editorOptions]="{ disabled: true }"></dxi-item>
                        <dxi-item
                            dataField="paymentMethodId"
                            [label]="{ text: 'Payment Method' }"
                            editorType="dxSelectBox"
                            [editorOptions]="{ items: vendorPaymentMethods, displayExpr: 'name', valueExpr: 'id', showClearButton: true }"
                        ></dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="2">
                        <dxi-item
                            dataField="defaultLineItemId"
                            [label]="{ text: 'Default Line Item' }"
                            editorType="dxSelectBox"
                            [editorOptions]="{ items: purchaseOrderLineItems, displayExpr: 'name', valueExpr: 'id' }"
                        ></dxi-item>
                        <dxi-item
                            dataField="termsId"
                            [label]="{ text: 'Terms' }"
                            editorType="dxSelectBox"
                            [editorOptions]="{ items: vendorTerms, displayExpr: 'name', valueExpr: 'id' }"
                        ></dxi-item>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Notes">
                    <dxi-item dataField="notes" [label]="{ text: 'Shipping Notes' }" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
                    <dxi-item dataField="internalNotes" [label]="{ text: 'Internal Notes' }" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group">
                <dxi-item itemType="group" caption="Remit Address">
                    <dxi-item dataField="remitAddress1" [label]="{ text: 'Address 1' }"></dxi-item>
                    <dxi-item dataField="remitAddress2" [label]="{ text: 'Address 2' }"></dxi-item>
                    <dxi-item itemType="group" [colCount]="3">
                        <dxi-item dataField="remitCity" [label]="{ text: 'City' }" [colSpan]="2"></dxi-item>
                        <dxi-item
                            dataField="remitState"
                            [label]="{ text: 'State' }"
                            editorType="dxSelectBox"
                            [editorOptions]="{ items: states, showClearButton: false }"
                        ></dxi-item>
                        <dxi-item dataField="remitPostalCode" [label]="{ text: 'Zip' }"></dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="3">
                        <dxi-item dataField="remitPhone" [label]="{ text: 'Remit Phone' }"></dxi-item>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Address">
                    <dxi-item dataField="address1" [label]="{ text: 'Address 1' }"></dxi-item>
                    <dxi-item dataField="address2" [label]="{ text: 'Address 2' }"></dxi-item>
                    <dxi-item itemType="group" [colCount]="3">
                        <dxi-item dataField="city" [label]="{ text: 'City' }" [colSpan]="2"></dxi-item>
                        <dxi-item dataField="state" [label]="{ text: 'State' }" [visible]="vendor.country !== 'US'"></dxi-item>
                        <dxi-item
                            dataField="state"
                            [label]="{ text: 'State' }"
                            editorType="dxSelectBox"
                            [editorOptions]="{ items: states, showClearButton: false }"
                            [visible]="vendor.country === 'US' || true"
                        ></dxi-item>
                        <dxi-item dataField="postalCode" [label]="{ text: 'Zip' }"></dxi-item>
                        <dxi-item
                            dataField="country"
                            [label]="{ text: 'Country' }"
                            editorType="dxSelectBox"
                            [editorOptions]="{ items: countries, showClearButton: false }"
                        ></dxi-item>
                        <dxi-item dataField="countryOther" [label]="{ text: 'Country Other' }" [visible]="vendor.country === 'OTHER'"></dxi-item>
                    </dxi-item>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</div>
